import { TURNS_ON_OPTIONS } from '../TURNS_ON_OPTIONS';
import { TurnsOnOptionIdType } from '../types';

const DEFAULT_ID: TurnsOnOptionIdType = 'feminine_body_surprise';
const DEFAULT_TITLE = TURNS_ON_OPTIONS[0].title;

export const getTurnsOnChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): TurnsOnOptionIdType | null => {
  const id = TURNS_ON_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getTurnsOnChoiceTitleById = (
  id: TurnsOnOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = TURNS_ON_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
